function rampMenu(visual, vcid, vcgid) {
    /// <summary>
    /// This object does the complete menu and highchart handling in the ramp archive. <br/>
    /// It generates proper ramp and ramp signal parameters, does the date handling and menu hiding/showing stuff. 
    /// Author: ARF<br />
    /// Date: 3.2.2013?<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.2.1 - 12.6.2017 (MWI)                                         *<br />
    /// **********************************************************************<br />
    /// * - disabled calling of rampSignalList in init if the div is not available*<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.2.0 - 12.6.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - integrated the call of the ramp signal list - removed the rampCharts.js *<br />
    /// **********************************************************************<br />
    /// *** v1.1.7 - 25.1.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - integrated the switching between the old archive charts and the new signal tag list (RampSignalList) *<br />
    /// **********************************************************************<br />
    /// *** v1.1.6 - 17.3.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - completely refactored the comparison interval handling                *<br />
    /// * - the complete handling has been moved to the serverside settings.setAutoComparisonDates function   *<br />
    /// **********************************************************************<br />
    /// *** v1.1.5 - 22.2.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added chart type (spline, column,areaspline)  functionality to the ramp menu                *<br />
    /// **********************************************************************<br />
    /// *** v1.1.4 - 17.2.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added addFavorites functionality to the ramp menu                *<br />
    /// **********************************************************************<br />
    /// *** v1.1.3 - 9.2.2016  - MWI                                         *<br />
    /// **********************************************************************<br />
    /// * - added setDirty call to .imgBack, .imgNext and DatePicker onSelect *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.1.2 - 5.2.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - simplified the met axis option call                              *<br />
    /// **********************************************************************<br />
    /// *** v1.1.1 - 1.2.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - simplified the met axis option call                              *<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 3.12.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - refactored for new menu design                                   *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.7.2015                                                *<br />
    /// **********************************************************************<br />
    /// * - refactored and documented                                        *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.vcC = new vcCommon();
    this.vcVisual = new vcVisual();
    this.userOptions = new vcUserOptions();
    this.visual = visual;
    this.vcid = vcid;
    this.vcgid = vcgid;
    this.intervalCounter = 1;
    this.signalTypeTemperature = 3;
    this.param = null;
    this.signalParam = null;
    this.datatype = 1;
    this.interval = 1;
    this.start = "";
    this.end = "";
    this.cumulated = false;
    this.usePrice = false;
    this.useCo2 = false;
    this.showHr = false;
    this.hrChartType = -1;
    this.dom = false;
    this.dirty = false;
    this.bSingleValuesAsConsumption = false;
    this.bSortDataDescending = false;

    this.resources = function () {
        this.noFixInterval = '';
        this.noFlexInterval = '';
        this.noUserDefInterval = '';
        this.continueOnHighDataAmount = '';
        this.days = '';
        this.months = '';
        this.years = '';
    }

    this.hiddenSeries = null;
    //this.rampCharts = null;
    
    //needed to find out if all visuals have been loaded before starting the chart
    this.initCounter = 0;
   
    this.chartWidth = parseInt(this.visual.find(".rampframe").width(), 10);
    this.chartHeightSingle = parseInt($("#divRamp1").height());
    this.chartHeightMultiple = this.chartHeightSingle ; //750
    this.chartHeightMultipleMet = this.chartHeightSingle ;
    this.interventionWidth = this.chartWidth - 5;
    this.interventionHeight = 760;
    this.maximumSeriesPoints = 8000;

   //first of all, init the user options
    this.initUserOptions();

}

rampMenu.prototype.events = function (event) {
    /// <summary>
    /// This function handles all VCMQ-events.
    /// </summary>
    // ReSharper disable once UseOfImplicitGlobalInFunctionScope
    var me = _rampMenu;
    
    switch (event.msg) {
        
  
        case 'CHART_SIGNALLIST_INIT':
            //sent by RampSignalList when ready to go
            _VCMQ.produce(me.visual, me.vcgid, 'CHART_INIT', '');
            me.visual.find('.btnShowInterventions').button('enable');

           
            break;
        case 'CHART_INIT':
            me.initRamp();
           
            break;

        case 'CHART_INIT_WAITING':
            //when initializing the chart for the first time wait for signals and rules which get loaded
            me.initCounter++;
            if (me.initCounter === 2) {
                _VCMQ.produce(me.visual, me.vcgid, 'CHART_INIT', '');
                me.visual.find('.btnShowInterventions').button('enable');
               
            }
            break;
        case 'CHART_DIRTY':
            me.setDirty(true);
            break;

        case 'CHART_SETTINGS':
            me.generateChartParameterForFavorites();
            break;

        case 'CHART_CLOSE_FAVORITES':
            me.dialog.dialog('close');
            break;
            
        case 'CHART_FAVORITES_LOADED':
            me.dialog.loaded=true;
            break;

        case 'GET_RAMP_DATE_INIT':
            me.broadcastChangedDate(true);
            _VCMQ.produce(me.visual, me.vcgid, 'SHOW_HR', me.visual.find("#selHr").hasClass("ui-selected"));

            break;

        //case 'EXPORT_URL':
        //    me.getUrlExport();
        //    break;


        //case 'GET_EXPORT_URL_SETTINGS':
        
        //    me.ShareUrlSettings = event.values;
        //    break;

    }
}


rampMenu.prototype.initUserOptions = function () {
    /// <summary>
    /// This function fetches existing user options and prepares the initial settings.
    /// </summary>
    var me = this;
    try {
        me.visual.find(" #divShowConsumption, #divArchiveResolution").show();
        me.dom = ($("#adminPanel").length > 0);
        if (me.dom) {
          //  me.visual.find("#divShowInvalidValues, #divShowConsumption, #divArchiveResolution").show();
            me.visual.find("#divShowInvalidValues").show();
        }

        me.userOptions.getUserOptions({ 'optgroupid': 'rampmenu' }, function (result) {

           if (result == null) { me.init(); return true }
           if (result.rows === null) { alert(me.resources.errorOnLoad); return false; }

            for (var i = 0; i < result.rows.length; i++) {
                if (result.rows[i].optid < 20) {
                    me.visual.find(".useroption[data-optid=" + result.rows[i].optid + "]")
                        .prop('checked', result.rows[i].bval);
                } else {
                    switch (result.rows[i].optid) {
                        case 20:
                            me.visual.find('#ddlArchiveResolution').val(result.rows[i].dval);
                            break;
                        //case 21:
                           
                        //    me.visual.find('.chbData').prop("checked", false);
                        //    me.visual.find(".chbData[data-dataid='" + result.rows[i].dval + "']").prop("checked", true);
                        //    break;
                    default:
                    }
                }
            }
            me.init();
           return true;
        });

    } catch (ex) { writeError('rampMenu.js.initUserOptions', ex);}

}

rampMenu.prototype.init = function () {
    /// <summary>
    /// This function does all initial settings and inits click and event handlers.
    /// </summary>
    var me = this;
    var iUserOption = 0;
    try {
       
        me.visual.find("#divRamp" + me.vcid).html(me.vcC.getLoadingIcon());
        me.visual.find('.btnShowInterventions').button().show().click(function () {
            if (me.visual.find("#divInterventions").is(":visible")) {
                me.toggleInterventions(false);
            } else {
                me.toggleInterventions(true);
                me.setDirty();
            }
        }).button('disable');


        if (me.dom) {
            me.visual.find("#hrmenu").show();
          


        } else {
            me.visual.find("#hrmenu").hide();
            me.visual.find("#ddlHrType").children("option[value^=3]").hide();
            me.visual.find("#ddlHrType").children("option[value^=4]").hide();
            me.visual.find("#ddlHrType").children("option[value^=5]").hide();
        }
        //me.showHr = true;
        //me.visual.find(" .selHr").addClass("ui-selected");


        //init the eventhandler after the initiation of the two button handler 
        _VCMQ.addConsumer(this.vcgid);
        _VCMQ.consume(this.visual, this.vcgid, this.events);

        me.visual.find('#btnShowChart').click(function () {
            _VCMQ.produce(me.visual, me.vcgid, 'CHART_INIT', '');
        }).show();

        //init the update events for the user options

        me.visual.find('.useroption').change(function () {
            iUserOption = parseInt($(this).attr('data-optid'), 10);
            if (iUserOption < 20) {
                me.userOptions.setUserOptions({ 'optgroupid': 'rampmenu', 'optid': iUserOption,'bval': $(this).prop('checked')},function() {});
            } else {
              
                switch (iUserOption) {
                    case 20:
                        me.userOptions.setUserOptions({'optgroupid': 'rampmenu', 'optid': iUserOption,'dval': $(this).val()},function() {});
                        break;
                default:
                }
               
            }
        });


        if (me.visual.find("#divRampChartSignalList1").length > 0) {
            me.visual.find("#divRampChartSignalList1").show();

            me.vcVisual.addVisualBaseByName('divRampChart',"VISUAL_RAMP_SIGNALLIST","SignalList1",getCurrentTimestamp(),parseInt(me.visual.find("#divRampChartSignalList1").height(), 10),parseInt(me.visual.find(".rampcharts").width(), 10),JSON.stringify({ 'SendRampInitEvent': true }),'',1);
        }

        //btn reload chart
        me.visual.find('#btnShowChart').click(function () {
            me.visual.find('#divRamp1').show();
            me.visual.find('#divRampCharts').hide();
            // me.visual.find('#divRuleEditorFrame').hide();
            me.visual.find('#btnSelection').removeClass('isSelected');

        });
        //button for showing the chart menu
        me.visual.find('#btnSelection').click(function () {
            if (me.visual.find(this).hasClass("active")) {
                // me.visual.find('#divRuleEditorFrame').hide();
                if (me.visual.find(this).hasClass('isSelected')) {
                    me.visual.find('#divRamp1').show();
                    me.visual.find('#divRampCharts').hide();
                    me.visual.find(this).removeClass('isSelected');
                } else {
                    me.visual.find('#divRampCharts').show();
                    me.visual.find('#divRamp1').hide();
                    me.visual.find(this).addClass('isSelected');
                }
            }
        });

        //init tabs
        me.visual.find('#topmenu').tabs().removeClass('ui-widget-content');
        me.visual.find('#typemenu, #modus').selectable();


        me.visual.find("#selCumulated,.selUsePrice,.selUseCo2,.selHr").off("click").on("click", function() {
            $(this).toggleClass("ui-selected");
           

            if ($(this).hasClass('selUsePrice')) {
               me.visual.find('.selUseCo2').removeClass('ui-selected');
            }
            if ($(this).hasClass('selUseCo2')) {
                me.visual.find('.selUsePrice').removeClass('ui-selected');
            }
            me.cumulated = me.visual.find('#selCumulated').hasClass('ui-selected');
            me.usePrice = me.visual.find('.selUsePrice').hasClass('ui-selected');
            me.useCo2 = me.visual.find('.selUseCo2').hasClass('ui-selected');
            //if co2 is active - price must be active true!!
            if (me.useCo2) { me.usePrice = true };



            if (me.visual.find('.selHr').hasClass('ui-selected')) {
                _VCMQ.produce(me.visual, me.vcgid, 'SHOW_HR', true);
                me.showHr = true;
                //#selCumulated,.selUsePrice, #selInterval3, #selInterval5, .comparecol1
                me.visual.find(".hideHr").hide();
                me.visual.find(".showHr").show();
                me.visual.find(".noHr").css("opacity", 0.3).css("pointer-events", "none");
                //me.visual.find('#selCumulated').hasClass('ui-selected')
                me.visual.find("#selInterval3, #selInterval5").removeClass("ui-selected");
                me.visual.find("#selInterval1").addClass("ui-selected");
                me.setInterval();


            } else {
                _VCMQ.produce(me.visual, me.vcgid, 'SHOW_HR', false);
                me.showHr = false;
                me.visual.find(".hideHr").show();
                me.visual.find(".showHr").hide();
                me.visual.find(".noHr").css("opacity", 1).css("pointer-events", "auto");
            }


            me.setDirty(true);
            me.broadcastChangedDate();
        });
        me.visual.find(".chbCompare, .chb ").off("click").on("click",
            function() {
                if ($(this).parents(".col").css("opacity") === 1) {
                    me.setDirty(true);
                }
            });

        me.visual.find("#ddlStartingHour, #ddlArchiveResolution").on("change", function () { me.setDirty(true) });

        me.setInterval();
        me.visual.find('#intervalmenu').selectable({
            selected: function () {
                me.setInterval();
                me.setDirty(true);
        }});
        me.setDatatype();
        me.visual.find('#typemenu').selectable({
            selected: function () {
          
            me.setDatatype();
            me.setDirty(true);
        }});

        me.visual.find("#divSortDataDescending").off("click").on("click", function () {
            me.setDirty(true);
            $(this).toggleClass("button-toggle-active");
            if ($(this).hasClass("button-toggle-active")) {
                me.visual.find("#selCumulated,.selUsePrice, #iconPanel #optionShowIntervention, #divStartingHour").css("opacity", 0.2);
                me.visual.find(".rampExportIcon, #divStartingHour").hide();
            } else {
                me.visual.find("#selCumulated,.selUsePrice, #iconPanel #optionShowIntervention,.rampExportIcon, #divStartingHour").css("opacity", 1);
                me.visual.find(".rampExportIcon,#divStartingHour").show();
            }

        }).button();
      

        me.visual.find(".seriesType").off("click").on("click", function () { me.setSeriesType(this); });
        

        me.FillNullValues = true;
        me.setComparison();
        me.setDataMenu();
        me.visual.find('.chbCompare').click(function () { me.visual.find('.chbCompare').not("#" + $(this).attr('id')).prop('checked', false); me.setComparison();});
        me.visual.find('.chbDate').click(function () { me.visual.find('.chbDate').not("#" + $(this).attr('id')).prop('checked', false); me.setInterval() });

        me.visual.find('.dataMenu .head .button-toggle').click(function () {
           
            if ($(this).hasClass("inactive") === false) {
                me.setDirty(true);
                me.visual.find('.dataMenu .head .button-toggle').removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                me.setDataMenu();
            }
            
        });


        me.visual.find('.dataMenu .content .button-toggle').click(function () {
            $(this).parents(".data-menu-content").find(".button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");

            me.setDirty(true);
            me.setDataValues();
        });

        me.initMainCalendar();
        me.initIntervalCalendar(me.visual.find("#txtDateUserDefStart"), me.visual.find("#txtDateUserDefEnd"), "minDate");
        me.initIntervalCalendar(me.visual.find("#txtDateUserDefEnd"), me.visual.find("#txtDateUserDefStart"), "maxDate");
        me.initIntervalCalendar(me.visual.find("#txtCompareFixStart"), me.visual.find("#txtCompareFixEnd"), "minDate");
        me.initIntervalCalendar(me.visual.find("#txtCompareFixEnd"), me.visual.find("#txtCompareFixStart"), "maxDate");

        //fix the width of the bottom menu
        var w = parseInt(me.visual.find(".topmenu").outerWidth(), 10);
        var w1 = w - (parseInt(me.visual.find("#btnSelection").outerWidth(), 10) + parseInt(me.visual.find("#btnShowChart").outerWidth(), 10)) - 40;
      
        me.visual.find(".bottommenu").width(w1);
        me.visual.find(".bottommenu, .optionmenu").show();

        var w2 = w - parseInt(me.visual.find(".chart-frame").outerWidth(), 10) - 30;
    
        me.visual.find(".selection-frame").width(w2);
      

        //set the standard date settings
        me.visual.find("#chbDateStandard").prop('checked', true);
        me.visual.find(".calendercontainer, #divCalendar").show();
        me.visual.find('.userdefdate .chb').click(function() {
            if ($(this).attr("id") === "chbDateStandard") {
                me.visual.find(".calendercontainer, #divCalendar").show();
                me.visual.find("#divDateUserDef").hide();
            } else {
                me.visual.find(".calendercontainer, #divCalendar").hide();
                me.visual.find("#divDateUserDef").show();
            }
            me.setDirty(true);
        });

        //inits the dialog for adding charts to favorites
        me.initBtnFavorites();


        //me.dialogUrl = $("<div>").attr("id", "infoDialog").css({ display: "none", overflow: "none!important" });
        //me.dialogUrl.loaded = false;
        //me.dialogUrl.dialog({
        //    autoOpen: false, modal: true, resizable: false,
        //    dialogClass: "saveDialog",
        //    title: "",
        //    closeOnEscape: true,

        //    position: { my: 'top-90%', at: 'center', of: window },
        //    buttons: {
        //        "close": function () { me.dialogUrl.dialog('close'); }
        //    }
        //});

    } catch (ex) { writeError('rampMenu.js.init', ex); return false; }
    return false;
}

rampMenu.prototype.generateChartParameter = function () {
    /// <summary>
    /// Based on the current menu and chart settings this function generates 
    /// the ramp parameters and a list of ramp signal parameters for each series.<br/>
    /// It handles the different settings for dates and user defined dates as well. <br/>
    /// Here, everything is generated the ramp chart will need.
    /// </summary>
    var me = this;
    var i,j;
    var rule, bsaid,  ruleType, series;
    var dtCompareStart;
    var dtCompareEnd;
    var dtStart;
    var dtEnd;
    var signalParam = { 'series': [] };
    
    var lstRule = { 'rules': [] };
    var meta = {};
   
    var seriesType = "spline";
    var signals;
    try {


        seriesType = me.visual.find(".seriesType.active").attr("data-type");

        //set proper dates
        me.start = me.visual.find('.txtDateShow').val();
        me.start = me.getStartDate(me.start);
        me.end = me.getEndDate(me.start);
       
        //add the temperature signal if it is not selected but the button is active
        signals = me.getSelectionList('#divRampChartSignalList1 #div-entries li.isSignal.tagFound.menuFilterFound.selected', 'bsaid');
        var temperature = me.getTemperatureFromSignalList();
        for (i = 0; i < temperature.length; i++) {if (signals.indexOf(temperature[i]) === -1) {signals.push(temperature[i]);}}
       


        lstRule = me.getRulesFromSignalList();
        meta = me.getMetaSelectionList('#divRampChartSignalList1 #div-meta-types li.selected');



        //get all menu settings
        var bFixTooltip = me.visual.find('#chbFixTooltip').prop('checked');
        var bNoZoom = me.visual.find('#chbNoZoom').prop('checked');
        //var bShowInvalidValues = true;
        var bShowInvalidValues = me.visual.find('#chbShowInvalidValues').prop('checked');

        var bSeparateDataAxis = me.visual.find('#chbSeparateDataAxis').prop('checked');
        var bShowPlotLines = me.visual.find('#chbShowPlotLines').prop('checked');
        var bFillNullValues = me.visual.find('#chbFillNullValues').prop('checked');
        var bShowIntervention = me.visual.find('#chbShowIntervention').prop('checked');
        //set the setting for separate temperature axis
        var bSeparateMetAxis = me.visual.find('#chbShowMet').prop('checked');

        var iStartingHour = parseInt(me.visual.find('#ddlStartingHour').val());
        var bGetSingleValuesAsConsumption = me.bSingleValuesAsConsumption;
        var bShowUnsmoothedValues = me.visual.find('#chbShowSmoothedValues').prop('checked') === false;
        var iArchiveResolution = me.visual.find('#ddlArchiveResolution').val();


        bGetSingleValuesAsConsumption = me.visual.find('#chbShowConsumption').prop('checked');


        //UseLimits
     

        var param = {
            'loggerID': 'blid',
            'showLogo': true,
            'isCumulated': me.cumulated,
            'usePrices': me.usePrice,
            'useCo2AsPrice': me.useCo2,
            'StartingHour': iStartingHour,
            'fixTooltip': bFixTooltip,
            'ShowPlotLines': bShowPlotLines,
            'datatype': me.datatype,
            'FillNullValues': bFillNullValues,
            'ShowIntervention': bShowIntervention,
            'ListHiddenSeries': me.hiddenSeries.lstHiddenSeries,
            'HideSeries': true,
            'ShowInvalidValues': bShowInvalidValues,
            'NoZoom': bNoZoom,
            'separateMetAxis': bSeparateMetAxis,
            "GetSingleValuesAsConsumption": bGetSingleValuesAsConsumption,
            "ShowZstForSingleValues": false,
            "isArchive": true,
            "ShowUnsmoothedValues": bShowUnsmoothedValues,
            "ArchiveResolutionSingleValues": iArchiveResolution, 
            "useLimits": me.visual.find('#chbIgnoreChartLimits').prop('checked') === false
    };



        //we deactivate prices, cumulation, interventions and meta data when we want to sort the data descending
      
        if (me.bSortDataDescending) {
            param.isCumulated = false;
            param.usePrice = false;
            param.ShowIntervention = false;
            param.SortDataDescending = true;
            param.StartingHour = 0;
        }

        //param.GetSingleValuesAsConsumption = true;
        param.AutoDateUserDefInterval = 0;
        param.AutoComparisonInterval = 0;


        if (me.visual.find('#chbDateUserDef').prop('checked')) {
            if (me.visual.find('#txtDateUserDefStart').val().trim().length === 0 || me.visual.find('#txtDateUserDefEnd').val().trim().length === 0) { alert(me.resources.noUserDefInterval); return false; }
           //set the user defined dates
            me.start = me.visual.find('#txtDateUserDefStart').val();
            me.end = me.visual.find('#txtDateUserDefEnd').val();
            param.dateUserDef = true;
            //calculate the timespan between the userdefined start and end date and store it
            dtStart = $.datepicker.parseDate('dd.mm.yy', me.start);
            dtEnd = $.datepicker.parseDate('dd.mm.yy', me.end);
            var dif = dtEnd - dtStart;
            if (dif !== 0) {
                param.AutoDateUserDefInterval = parseInt(dif / (1000 * 3600 * 24 * -1));
            } else {
                param.AutoDateUserDefInterval = 0;
            }
        }

        param.startDate = me.start;
        param.endDate = me.end;

        //set the autpComparison intervals for comparison
        if (me.visual.find('#chbCompareFlexible').prop('checked')) {
            if (me.visual.find('#txtCompareFlexible').val().trim().length === 0) {
                alert(me.resources.noFlexInterval);
                return false;
            }
            //set the comparison interval
            param.AutoComparisonInterval = parseInt(me.visual.find('#txtCompareFlexible').val().trim(), 10);
        }

        if (me.visual.find('#chbCompareFix').prop('checked')) {
            if (me.visual.find('#txtCompareFixStart').val().trim().length === 0 || me.visual.find('#txtCompareFixEnd').val().trim().length === 0) { alert(me.resources.noFixInterval); return false; }
            dtCompareStart = $.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', me.visual.find('#txtCompareFixStart').val()));
            dtCompareEnd = $.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', me.visual.find('#txtCompareFixEnd').val()));
            if (((me.start === dtCompareStart) && (me.end === dtCompareEnd)) === false) {
                param.AutoComparisonInterval = 0;
                param.compareStartDate = dtCompareStart;
                param.compareEndDate = dtCompareEnd;
            }
        }
        if (me.visual.find('#chbCompareLastYear').prop('checked')) {
            param.AutoPreviousPeriodComparison = true;
        }

        if (me.showHr === false) {
            //add all rule series
            param.separateDataAxis = false;
            for (i = 0; i <= lstRule.rules.length - 1; i++) {
                param.separateDataAxis = true;

                signalParam.series.push({
                    'bsaid': lstRule.rules[i].bsaid,
                    'mtid': lstRule.rules[i].mtid,
                    'rid': lstRule.rules[i].rid,
                    'rule': lstRule.rules[i].rule,
                    'ruleType': 3,
                    'seriesType': seriesType
                });

            }
        }
        //add all signal series (if no meta types got selected)
        if (meta.length === 0) {
            for (i = 0; i <= signals.length - 1; i++) {
                rule = "[bsaid=" + signals[i] + "]"; bsaid = [signals[i]]; ruleType = 1;
                signalParam.series.push({ 'bsaid': bsaid, 'rule': rule, 'ruleType': ruleType, 'seriesType': seriesType });
            }
        }

        if (me.showHr === false) {
            if (me.bSortDataDescending === false) {

                //add all meta type series (if no signals got selected)
                if (signals.length === 0) {
                    for (i = 0; i <= meta.length - 1; i++) {
                        series = {}
                        if (meta[i].ismeta) {
                            series.ruleType = 2;
                        } else {
                            series.ruleType = 1;
                        }
                        series.seriesType = seriesType;
                        series.mtid = [];
                        series.bsaid = [];
                        series.rule = "";
                        if (meta[i].ismeta) {
                            series.rule = "[mtid=" + meta[i].id + "]";
                            series.mtid = [meta[i].id];


                        } else {
                            series.rule = "[bsaid=" + meta[i].id + "]";
                            series.bsaid = [meta[i].id];
                        }
                        signalParam.series.push(series);
                    }
                }
                //add series for signal / meta type calculation
                if (meta.length > 0 && signals.length > 0) {
                    for (i = 0; i <= signals.length - 1; i++) {
                        for (j = 0; j <= meta.length - 1; j++) {

                            series = {}

                            series.seriesType = seriesType;
                            series.mtid = [];
                            series.bsaid = [];
                            series.rule = "";


                            if (meta[j].ismeta) {
                                series.rule = "[bsaid=" + signals[i] + "] / [mtid=" + meta[j].id + "]";
                                series.bsaid = [signals[i]];
                                series.mtid = [meta[j].id];
                                series.ruleType = 0;

                            } else {
                                series.rule = "[bsaid=" + signals[i] + "] / [bsaid=" + meta[j].id + "]";
                                series.bsaid = [signals[i], meta[j].id];
                                series.ruleType = 3;
                            }

                            param.separateDataAxis = true;
                            signalParam.series.push(series);
                        }
                    }
                }
            }
        }
        //reset separate axis if option is deactivated
        if (bSeparateDataAxis === false) { param.separateDataAxis = false; }


        //ddlHrType
        me.hrChartType = -1;
        param.interval = me.interval;
        if (me.showHr) {


            param.ShowZstForSingleValues = false;
            me.hrChartType = parseInt(me.visual.find("#ddlHrType").val());
            switch (me.hrChartType)
            {
                case 1:
                    param.interval = 10;
                    param.HighResolutionAsRawData = true;
                    break;
                case 2:
                    param.interval = 10;
                    param.HighResolutionAsRawData = false;
                    break;
                case 3:
                    param.interval = 1;
                    param.ShowZstForSingleValues = true;
                    param.GetSingleValuesAsConsumption = false;
                    break;
                case 4:
                    //param.interval = -1;
                    param.HighResolutionAsRawData = true;
                    break;
                case 5:
                    param.interval = -1;
                    param.HighResolutionAsRawData = true;
                    break;


            }
          
          
        }
      
        me.param = param;
       
        me.signalParam = signalParam;


        return true;
    } catch (ex) { writeError('rampMenu.js.generateChartParamter', ex); return false; }
}




rampMenu.prototype.initRamp = function () {
    /// <summary>
    /// This function takes the generated ramp parameters, sets heights and widths and starts the chart.
    /// </summary>
    var me = this;
    var h;
    try {

        if (me.generateChartParameter() === false) { return false; }
     
        //ask for a confirmation if too much data should get generated
        if (me.validateDataAmount() === false) { return false };
    
        var sVisualName = me.getVisualName(me.param.interval);

       
        var sParam = JSON.stringify(me.param);
        var sSignalParam = JSON.stringify(me.signalParam);


        //send the config for the share url
        var p = JSON.parse(JSON.stringify(me.param));
        p.isArchive = false;
        p.UseSimpleBottomLegend = true;
        p.ShowExportIcons = false;
        p.ShowIntervention = false;


        var urlInfo = {
            'visualname': sVisualName,
            'parameter': JSON.stringify(p),
            'signalparameter': JSON.stringify(me.signalParam)
        } 

        if (sVisualName === "VISUAL_RAMP_CURRENT_VALUES_SIMPLE" || sVisualName === "VISUAL_RAMP_ONLINE" ) {
            urlInfo.info = { name: '', description: '' }                       
        } else {
           urlInfo.info = { name: '', description: '', startDate: me.param.startDate, endDate: me.param.endDate, dateUserDef: me.param.dateUserDef, interval: me.param.interval };

        }
       
        if (sVisualName === "VISUAL_RAMP_CURRENT_VALUES_SIMPLE") {
            urlInfo.info.interval = 1;
          
        }


        if (me.signalParam.series.length === 1) {
            urlInfo.info.bsaid = me.signalParam.series[0].bsaid[0];
        } else {
            urlInfo.info.bsaid = -1;
        }

        _VCMQ.produce(me.visual, "-1", 'GET_EXPORT_URL_SETTINGS',urlInfo);
      

        // ReSharper disable once AssignToImplicitGlobalInFunctionScope
        if (typeof (gc1) == 'function') { gc1(); gc1 = null; }

        me.toggleInterventions(false);
        me.visual.find('#divRamp' + me.vcid).html(me.vcC.getLoadingIcon());
       
        if (me.param.separateDataAxis === false && me.param.separateMetAxis === false) {
            h = me.chartHeightSingle;
        } else {
            if (me.param.separateMetAxis) {
                h = me.chartHeightMultipleMet;
            } else {
                h = me.chartHeightMultiple;
            }
        }
        //add the height for a virtual header to get a better height calculation
        h += 25; 
        me.visual.find('#divRamp' + me.vcid).height(h);
        me.visual.find('#divRamp' + me.vcid).width(me.chartWidth);

        me.setDirty(false);



            me.vcVisual.addVisualBaseByName('divRamp', sVisualName, me.vcid, me.start, h, me.chartWidth, sParam, sSignalParam, 1,
               function () {

                   if (me.visual.find("#divSortDataDescending").hasClass("button-toggle-active")) {
                       me.visual.find(".rampExportIcon").css("opacity", 0);
                   }

                   me.visual.find(".favoriteMenu").show();
                
               },function() {
                   me.visual.find('#divRamp' + me.vcid).html("<div class='error'>" + me.resources.loadingDataTookTooLong + "</div>");
                   me.visual.find(".favoriteMenu").hide();
                });

    } catch (ex) { writeError('rampMenu.js.initRamp', ex); return false; }
    return false;
}





rampMenu.prototype.getVisualName = function (interval) {
    /// <summary>
    /// This function returns the visual name based on the selected time interval.<br/>
    /// </summary>
    var me = this;
    var sVisualName = "";
        switch (interval) {
        case 1:
            sVisualName = 'VISUAL_RAMP_SINGLE';
            break;
        case 3:
            sVisualName = 'VISUAL_RAMP_DAILY';
            break;
        case 5:
            sVisualName = 'VISUAL_RAMP_MONTHLY';
            break;
            case 10:
                sVisualName = 'VISUAL_RAMP_HR';
                break;
         
              
    }
  

    if (me.showHr) {

        switch (me.hrChartType) {
            case 4:
                sVisualName = 'VISUAL_RAMP_ONLINE';
                break;

            case 5:
                sVisualName = 'VISUAL_RAMP_CURRENT_VALUES_SIMPLE';
                break;
        }
    }
    return sVisualName;
}



rampMenu.prototype.getSelectionList = function (item, prefix) {
    /// <summary>
    /// This function returns a list with all selected signal ids. 
    /// </summary>
    var me = this;
    try {
        var lstSignal = new Array();

        me.visual.find(item).each(function () {
           var id = this.id;
           id = id.replace(prefix, '');
           lstSignal.push(parseInt(id));
        });
        return lstSignal;
    } catch (ex) { writeError('rampMenu.js.getSelectionList', ex); return false; }
}


rampMenu.prototype.getMetaSelectionList = function (item) {
    /// <summary>
    /// This function returns a list with all selected signal ids. 
    /// </summary>
    var me = this;
    try {
        var lst = [];
       
        me.visual.find(item).each(function () {
            if ($(this).hasClass("notAllowedInterval") === false) {
                lst.push({ 'id': parseInt($(this).data("id"), 10), 'ismeta': $(this).data("ismeta") });
            }
        });
        return lst;
    } catch (ex) { writeError('rampMenu.js.getMetaSelectionList', ex); return false; }
}



rampMenu.prototype.getTemperatureFromSignalList = function () {
    /// <summary>
    /// This function returns a list if temperature signal ids from the ramp signal list.<br/> 
    /// Note: if the 'add temperature signals' button is not actived the list will be empty
    /// </summary>
    var me = this;
    try {
        var lstSignal = new Array();
        var ids = me.visual.find("#divRampChartSignalList1 #btn-add-temp.button-toggle-active").data("ids");
        if (typeof(ids) !== 'undefined') {
            lstSignal = ids;
        }
       
        return lstSignal;
    } catch (ex) { writeError('rampMenu.js.getTemperatureFromSignalList', ex); return false; }
}

rampMenu.prototype.getRulesFromSignalList = function () {
    /// <summary>
    /// This function returns a list with all selected rule information. 
    /// </summary>
    var me = this;
    var lstBsaid, lstMtid;
    var rid = -1;
    var rule;
    var obj;
    var lst;
    try {
        var lstRule = { 'rules': [] };
        me.visual.find('#divRampChartSignalList1 .vc-list-table li.isRule.tagFound.menuFilterFound.selected').each(function () {

         
                rid = $(this).data("id");
                obj = $(this).find(".archive-rule");
                rule = obj.data("rule");
                lst = obj.data("rule_bsaid");
                if (lst !== null) {
                lstBsaid = lst.replace('{', '').replace('}', '').split(',').map(Number);
                } else { lstBsaid = []; }
                lst = obj.data("rule_mtid");
                if (lst !== null) {
                    lstMtid = lst.replace('{', '').replace('}', '').split(',').map(Number);
                } else {lstMtid = [];}
                lstRule.rules.push({ 'rid': rid, 'rule': rule, 'bsaid': lstBsaid, 'mtid': lstMtid });
            
        });
        return lstRule;
    } catch (ex) { writeError('rampMenu.js.getRulesFromSignalList', ex); return false; }
}



rampMenu.prototype.setInterval = function () {
    /// <summary>
    /// This function sets all needed settings when changing the time interval.<br/>
    /// It changes the data type if it's necessary as well.
    /// </summary>
    var me = this;
    try {
     
          
        var id = me.visual.find('.interval.ui-selected').attr('id');
       
        id = parseInt(id.replace("selInterval", ''));

        me.visual.find("#btnShowPeaks").css("opacity", 1).removeClass("inactive");

        me.setMainDateFormat(id);
        me.interval = id;
       
        switch (id) {
            case 1: //single values
              
                me.visual.find('#divStartingHour').removeClass("active");
                me.visual.find('#ddlArchiveResolution').prop("disabled", false);
                me.visual.find('#divShowUnsmoothedValues').css("opacity", 1);
                me.visual.find('#ddlStartingHour').prop("disabled", true);
                me.intervalCounter = 1; //switch one day
                me.visual.find('#spanCompareFlexibleCaption').html(me.resources.days);
                me.visual.find(".txtDateInterval").val(me.intervalCounter);

                
                me.visual.find("#btnShowPeaks").css("opacity", 0.4).addClass("inactive");

                if (me.visual.find("#btnShowPeaks").hasClass("button-toggle-active")) {
                    me.visual.find("#btnShowPeaks").removeClass("button-toggle-active");
                    me.visual.find("#btnShowValues").addClass("button-toggle-active");
                    me.setDataMenu();
                }

                break;
            case 3://daily values
                me.visual.find('#divStartingHour').addClass("active");
               // me.visual.find('.rampmenu #typemenu li').removeClass("inactive");
                me.visual.find('#ddlArchiveResolution').prop("disabled", true);
                me.visual.find('#divShowUnsmoothedValues').css("opacity", 0.5);
                me.visual.find('#ddlStartingHour').prop("disabled", false);
                me.intervalCounter = 28;//swich at least 28 day (YES, that's a hack)
                me.visual.find('#spanCompareFlexibleCaption').html(me.resources.months);
                me.visual.find(".txtDateInterval").val(me.intervalCounter);
                break;
            case 5://monthly values
                me.visual.find('#divStartingHour').addClass("active");
                //me.visual.find('.rampmenu #typemenu li').removeClass("inactive");
                me.visual.find('#ddlArchiveResolution').prop("disabled", true);
                me.visual.find('#divShowUnsmoothedValues').css("opacity", 0.5);
                me.visual.find('#ddlStartingHour').prop("disabled", false);
                //me.setDatatype();
                me.intervalCounter = 365;
                me.visual.find('#spanCompareFlexibleCaption').html(me.resources.years);
                me.visual.find(".txtDateInterval").val(me.intervalCounter);
                break;
        }
        me.showInterventionEditor(me.visual.find('.txtDateShow').val());
        me.broadcastChangedDate();
        if (me.visual.find('#chbDateUserDef').prop('checked')) { me.visual.find('#spanCompareFlexibleCaption').html(me.resources.periods); }
        me.setDataMenu();
        me.setDataValues();
        return true;
    } catch (ex) { writeError('rampMenu.js.setInterval', ex); return false; }
}

rampMenu.prototype.setMainDateFormat = function (id) {
    /// <summary>
    /// This function sets the date format for the given time interval<br/>
    /// </summary>
    var me = this;
    try {
        switch (id) {
            case 1: me.visual.find(".txtDate").val($.datepicker.formatDate('dd.mm.yy', $.datepicker.parseDate('dd.mm.yy', me.visual.find(".txtDateShow").val())));break;
            case 3:me.visual.find(".txtDate").val($.datepicker.formatDate('M yy', $.datepicker.parseDate('dd.mm.yy', me.visual.find(".txtDateShow").val())));break;
            case 5:me.visual.find(".txtDate").val($.datepicker.formatDate('yy', $.datepicker.parseDate('dd.mm.yy', me.visual.find(".txtDateShow").val())));break;
        }
        return true;
    } catch (ex) { writeError('rampMenu.js.setMainDateFormat', ex); return false; }
}

rampMenu.prototype.setDatatype = function () {
    /// <summary>
    /// This function sets the selected data type.<br/>
    /// </summary>
    var me = this;
    try {

        //me.visual.find("#divExpertMonthlyMenu").show();
        //if (me.interval > 1) {
        //    var id = me.visual.find('.datatype.ui-selected').attr('id');
        //    id = parseInt(id.replace("selDatatype", ''),10);
        //    me.datatype = id;
        //} else {
        //    me.datatype = 1; //for single values only single values are allowed :-)
        //}

    
        return false;
    } catch (ex) { writeError('rampMenu.js.setDatatype', ex); return false; }
}



rampMenu.prototype.setDataMenu = function () {
    /// <summary>
    /// This function sets the selected comparison settings.
    /// </summary>
    var me = this;

    try {
      
       me.visual.find(".data-menu-content").hide();
        //me.visual.find(".datatype").removeClass("ui-selected");
        //me.visual.find("#selDatatype" + me.datatype).addClass("ui-selected");

        if (me.visual.find("#btnShowValues").hasClass("button-toggle-active")) {
            me.visual.find("#div-values-menu").show();
            if (me.interval === 1) {
                me.visual.find("#div-btn-values-power").addClass("button-toggle-active").show();
                me.visual.find("#div-btn-values-consumption").removeClass("button-toggle-active").hide();
            } else {
                me.visual.find("#div-btn-values-power").removeClass("button-toggle-active").hide();
                me.visual.find("#div-btn-values-consumption").addClass("button-toggle-active").show();
            }
        
        }
      
        if (me.visual.find("#btnShowPeaks").hasClass("button-toggle-active")) {
            me.visual.find("#div-peaks-menu").show();
     
        }
      
        if (me.visual.find("#btnShowLoad").hasClass("button-toggle-active")) {
            me.visual.find("#div-load-menu").show();
    
        }

        me.setDataValues();
        return false;
    } catch (ex) { writeError('rampMenu.js.setDataMenu', ex); return false; }
}


rampMenu.prototype.setDataValues = function () {
    /// <summary>
    /// This function sets the selected comparison settings.
    /// </summary>
    var me = this;

    try {
        me.bSortDataDescending = false;
        me.bSingleValuesAsConsumption = false;
        if (me.visual.find("#btnShowValues").hasClass("button-toggle-active")) {
            if (me.interval === 1) {
                me.datatype = 1;

              //  me.bSingleValuesAsConsumption = me.visual.find("#div-btn-values-consumption").hasClass("button-toggle-active");

                //TODO: here
                me.bSingleValuesAsConsumption = me.visual.find('#chbShowConsumption').prop('checked');




            } else {
                if (me.visual.find("#div-btn-values-power").hasClass("button-toggle-active")) {
                    me.datatype = 5;
                } else {
                    me.datatype = 2;
                }
            }
        }

        if (me.visual.find("#btnShowPeaks").hasClass("button-toggle-active")) {
            switch (me.visual.find("#div-peaks-menu .button-toggle-active").attr("id")) {
                case "div-btn-power-min":
                    me.datatype = 3;
                    me.bSingleValuesAsConsumption = false;
                    break;
                case "div-btn-power-max":
                    me.datatype = 4;
                    me.bSingleValuesAsConsumption = false;
                    break;
                case "div-btn-consumption-min":
                    me.datatype = 3;
                    me.bSingleValuesAsConsumption = true;
                    break;
                case "div-btn-consumption-max":
                    me.datatype = 4;
                    me.bSingleValuesAsConsumption = true;
                    break;
            default:
            }
        }

        if (me.visual.find("#btnShowLoad").hasClass("button-toggle-active")) {
            me.bSortDataDescending = true;
            if (me.interval === 1) {
                me.visual.find("#div-btn-load-sum").html(me.resources.singleValues);
                me.datatype = 1;
            } else {
                me.visual.find("#div-btn-load-sum").html(me.resources.sumValues);
                me.datatype = 2;
            }        }
        return false;
    } catch (ex) { writeError('rampMenu.js.setComparison', ex); return false; }
}

rampMenu.prototype.setSeriesType = function (obj) {
    /// <summary>
    ///  This function switches the series types in the settings and sets the given series type icon as active
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".seriesType").removeClass("active" );
        $(obj).addClass("active");
        me.setDirty(true);

        return true;
    } catch (ex) { writeError('rampMenu.js.setSeriesType', ex); return false }

}

rampMenu.prototype.setComparison = function () {
    /// <summary>
    /// This function sets the selected comparison settings.
    /// </summary>
    var me = this;
    var found = false;
    try {
        if (me.visual.find("#chbCompareFlexible").is(":checked")) {
            me.visual.find("#divNoCompare,#divCompareFix,#divCompareLastYear").hide();
            me.visual.find("#divCompareFlexible").show();
            found = true;
        }
        if (me.visual.find("#chbCompareFix").is(":checked")) {
            me.visual.find("#divNoCompare,#divCompareFlexible,#divCompareLastYear").hide();
            me.visual.find("#divCompareFix").show();
            found = true;
        }
        if (me.visual.find("#chbCompareLastYear").is(":checked")) {
            me.visual.find("#divNoCompare,#divCompareFlexible,#divCompareFix").hide();
            me.visual.find("#divCompareLastYear").show();
            found = true;
        }
        if (found === false) {
            me.visual.find("#divCompareLastYear,#divCompareFlexible,#divCompareFix").hide();
            me.visual.find("#divNoCompare").show();
        }
        return false;
    } catch (ex) { writeError('rampMenu.js.setComparison', ex); return false; }
}

rampMenu.prototype.getStartDate = function (sDate) {
    /// <summary>
    /// This function returns the start date based on the selected time interval.<br/>
    /// </summary>
    var me = this;
    var dtTmp;
    try {
        switch (me.interval) {
            case 1:return sDate;
            case 3:
                dtTmp = $.datepicker.parseDate('dd.mm.yy', sDate);
                return '01.' + $.datepicker.formatDate('mm.yy', dtTmp);
            case 5:
                dtTmp = $.datepicker.parseDate('dd.mm.yy', sDate);
                return '01.01.' + $.datepicker.formatDate('yy', dtTmp);
        }
        return false;
    } catch (ex) { writeError('rampMenu.js.getStartDate', ex); return false; }
}

rampMenu.prototype.getEndDate = function (sDate) {
    /// <summary>
    /// This function returns the end date based on the selected time interval.<br/>
    /// </summary>
    var me = this;
    var dtTmp;
    try {
        switch (me.interval) {
            case 1:return sDate;
            case 3:
                dtTmp = $.datepicker.parseDate('dd.mm.yy', sDate);
                var lastDay = me.vcC.getDaysInMonth(parseInt($.datepicker.formatDate('mm', dtTmp)), parseInt($.datepicker.formatDate('yy', dtTmp)));
                return lastDay + '.' + $.datepicker.formatDate('mm.yy', dtTmp);
            case 5:
                dtTmp = $.datepicker.parseDate('dd.mm.yy', sDate);
                return '31.12.' + $.datepicker.formatDate('yy', dtTmp);
        }
        return false;
    } catch (ex) { writeError('rampMenu.js.getEndDate', ex); return false; }
}

rampMenu.prototype.validateDataAmount = function () {
    /// <summary>
    /// This function calculates the expected series points based on the current selection.<br/>
    /// If too many data got selected it asks for a confirmation.
    /// </summary>
    var me = this;
    try {

        if (typeof me.signalParam.series == 'undefined') { return true }

       var  iSeries = me.signalParam.series.length;
        var iDays = $.datepicker.parseDate('dd.mm.yy', me.end) - $.datepicker.parseDate('dd.mm.yy', me.start);
        iDays = (iDays / 1000 / 60 / 60 / 24) + 1;
        switch (me.interval) {
            case 1:
                iSeries = iSeries * iDays * 96; break;
            case 3:
                iSeries = iSeries * iDays; break;
            case 5:
                iSeries = parseInt(iSeries * iDays / 12); break;
        }
        if (typeof me.param.compareStartDate != 'undefined') {
            iSeries = iSeries * 2;
        }
        if (iSeries > me.maximumSeriesPoints) {
            if (confirm(me.resources.continueOnHighDataAmount, 'Validation') === false) { return false };
        }
        return true;
    } catch (ex) { writeError('rampMenu.js.validateDataAmount', ex); return false; }
}

rampMenu.prototype.initMainCalendar = function () {
    /// <summary>
    /// Lot's of date handling and nagivation ...<br/>
    /// </summary>
    var me = this;
    eval(me.visual.find("#divCalendar"));


   // me.broadcastChangedDate(true);

    me.visual.find(".txtDateInterval").val(me.interval);
    me.visual.find('.txtDateShow').change(function () {
        me.visual.find('.txtDate').val(me.visual.find('.txtDateShow').val());
        me.setMainDateFormat(me.interval);
        me.showInterventionEditor(me.visual.find('.txtDateShow').val());
        me.broadcastChangedDate();
    });

    me.visual.find('.imgBack').unbind('click').click(function () {
        var dt = $.datepicker.parseDate('dd.mm.yy', me.visual.find('.txtDateShow').val());
        dt.setDate(dt.getDate() - parseInt(me.visual.find('.txtDateInterval').val()));
        me.visual.find('.txtDateShow').datepicker('setDate', dt);
        me.setMainDateFormat(me.interval);
        me.showInterventionEditor(dt);
        me.setDirty(true);
        me.broadcastChangedDate();
    });
    me.visual.find('.imgNext').unbind('click').click(function () {
        var dt = $.datepicker.parseDate('dd.mm.yy', me.visual.find('.txtDateShow').val());
        dt.setDate(dt.getDate() + parseInt(me.visual.find('.txtDateInterval').val()));
        me.visual.find('.txtDateShow').datepicker('setDate', dt);
        me.setMainDateFormat(me.interval);
        me.showInterventionEditor(dt);
        me.setDirty(true);
        me.broadcastChangedDate();

    });
}


rampMenu.prototype.broadcastChangedDate = function (bInit) {
    /// <summary>
    /// This function sets the dirty state - used for refreshing info.
    /// </summary>
    var me = this;
    var start, end, userDef;
    try {


       


        bInit = (typeof b !== 'undefined') ? bInit : false;
        userDef = me.visual.find('#chbDateUserDef').prop('checked');
        if (me.visual.find('#chbDateUserDef').prop('checked')) {
            if (me.visual.find('#txtDateUserDefStart').val().trim().length === 0 || me.visual.find('#txtDateUserDefEnd').val().trim().length === 0) {return false;}
            //start = me.getStartDate(me.visual.find('#txtDateUserDefStart').val());
            //end = me.getEndDate(me.visual.find('#txtDateUserDefEnd').val());
            start = me.visual.find('#txtDateUserDefStart').val();
            end = me.visual.find('#txtDateUserDefEnd').val();
        } else {
            start = me.getStartDate(me.visual.find('.txtDateShow').val());
            end = me.getEndDate(me.visual.find('.txtDateShow').val());
        }


        if (bInit) {
            _VCMQ.produce(me.visual, me.vcgid, 'RAMP_DATE_INIT', { "interval": me.interval, "usePrice": me.usePrice, "startDate": start, "endDate": end, "dateUserDef": userDef });
        } else {
            _VCMQ.produce(me.visual, me.vcgid, 'RAMP_DATE_CHANGED', { "interval": me.interval, "usePrice": me.usePrice, "startDate": start, "endDate": end, "dateUserDef": userDef });

        }
       
       
        return true;
    } catch (ex) { writeError('rampMenu.js.broadcastChangedDate', ex);return false;}

}

rampMenu.prototype.initIntervalCalendar = function (from, to, limit) {
    /// <summary>
    /// This function is used to connect both user defined date calenders together.<br/>
    /// </summary>
    var me = this;
    from.datepicker({
        changeMonth: true,changeYear: true,
        showButtonPanel: true, showOn: 'button', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true,
        onClose: function (selectedDate) { to.datepicker("option", limit, selectedDate); },
        onSelect: function() {
            me.setDirty(true);
            me.broadcastChangedDate();
        }
    });
}


rampMenu.prototype.toggleInterventions = function (bShow) {
    /// <summary>
    /// This function toogles the interventions. :-)<br/>
    /// If the interventions get shown the expert menu get's hidden.
    /// </summary>
    var me = this;
    try {

        if (bShow === false) {
            me.visual.find(".btnShowInterventions").removeClass("button-active");
            me.visual.find("#btnSelection").removeClass("active").addClass("active");
            me.visual.find("#divRamp" + me.vcid).show();
            me.visual.find("#divInterventions").hide();
        } else {
          
            me.visual.find(".btnShowInterventions").addClass("button-active");
            me.visual.find("#btnSelection").removeClass("active");
           // me.visual.find("#divRampCharts,#divRamp" + me.vcid).hide();
            me.visual.find("#divInterventions").show();

            me.showInterventionEditor(me.visual.find('.txtDateShow').val());
        }
        return true;
    } catch (ex) { writeError('rampMenu.js.toggleInterventions', ex); return false; }
}


rampMenu.prototype.showInterventionEditor = function (dt) {
    /// <summary>
    /// This function inits the intervention management widget.<br/>
    /// </summary>
    var me = this;
    try {

        if (me.visual.find("#divInterventions").is(":visible") === false) {return true}

        me.visual.find("#divInterventionEditor22").html(me.vcC.getLoadingIcon());
        
        if (me.interval < 5) {
            me.visual.find("#divInterventions .note").hide();
            me.vcVisual.addVisualBaseByName("divIntervention", 'VISUAL_FORM_INTERVENTION', 'Editor22', dt, me.interventionHeight, me.interventionWidth, 'true', '', 1);
        } else {
            me.visual.find("#divInterventions .note").show();
            me.vcVisual.addVisualBaseByName("divIntervention", 'VISUAL_INTERVENTION_LIST', 'Editor22', dt, me.interventionHeight, me.interventionWidth, '', '', 1);
        }
        
        return true;
    } catch (ex) { writeError('rampMenu.js.showInterventionEditor', ex); return false; }
}




rampMenu.prototype.initBtnFavorites = function () {
    /// <summary>
    /// This function inits the button for adding charts to the favorite lists.<br/>
    /// It opens the widget in a jquery ui-dialog.
    /// </summary>
    var me = this;
    try {

        me.dialog = $("<div>").attr("id", "infoDialog").css({ display: "none" });
        me.dialog.loaded = false;
        me.dialog.dialog({ autoOpen: false, modal: true, resizable: false,
            dialogClass: "favoriteDialog",
            title: me.resources.favorites,
            closeOnEscape: false,
            beforeClose: function() {return me.dialog.loaded},
            position: { my: 'top-95%', at: 'center' , of:window},
            buttons: {
                "Cancel": function () { me.dialog.dialog('close'); return false; }
            }
        });
        //// ReSharper disable InvalidValue
        $('.favoriteDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        //init favorite button
        me.visual.find(".favoriteMenu #btnAddToFavorites").click(function () {
            //stop if the menu settings are invalid
            if (me.generateChartParameter() === false) { return false; }
            //ask for a confirmation if too much data should get generated
            if (me.validateDataAmount() === false) { return false };

            me.dialog.loaded = false;

            me.dialog.html("<div id='divFavoriteArchiveHandler1' class='FavoriteArchive'></div>");
            me.vcVisual.addVisualContentByName('divFavorite', "VISUAL_FAVORITES_ARCHIVE", "ArchiveHandler1", getCurrentTimestamp(), 700, 750, "", "", 1,
                  function () {
                      me.dialog.dialog("option", {"width": 770, "height": "auto" }).dialog("open");
                  }, function () { });
            return true;
        });
      

    } catch (ex) { writeError('rampMenu.js.initBtnFavorites', ex); }

}


rampMenu.prototype.generateChartParameterForFavorites = function () {
    /// <summary>
    /// This function inits the button for adding charts to the favorite lists.<br/>
    /// It opens the widget in a jquery ui-dialog.
    /// </summary>
    var me = this;
    var p;
    try {

        //INFO:  me.generateChartParameter() has been executed before opening the dialog box
        //Therefore, we don't have to validate everything again
        p = me.param;
        p.isArchive = false;
       
        var settings = {
            'visualname': me.getVisualName(me.param.interval),
            'param':p,
            'signalparam': me.signalParam
        }

        //console.info(settings);

        //send the settings as event
        _VCMQ.produce(me.visual, me.vcgid, 'CHART_SEND_SETTINGS', settings);


    } catch (ex) { writeError('rampMenu.js.generateChartParameterForFavorites', ex); }

}



rampMenu.prototype.setDirty = function (bSet) {
    /// <summary>
    /// This function sets the dirty state - used for refreshing info.
    /// </summary>
    var me = this;
    try {
        me.dirty = bSet;
      if (me.dirty) {
          me.visual.find("#btnShowChart").html("<i class='fa fa-sync-alt'></i><br />" + me.resources.reload);
      } else {
          me.visual.find("#btnShowChart").html("<i class='fa fa-check'></i><br />" + me.resources.loaded);
      }

    } catch (ex) { writeError('rampMenu.js.setDirty', ex); }

}

